import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { Login, Signup, VerifyEmail, VerifyEmailLanding, ResetPassword } from './lazyPages';

export default function AuthRoutes({ isAuthenticated }: { isAuthenticated: boolean }) {
  return (
    <>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
      />
      <Route
        path="/signup"
        element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Signup />}
      />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/verify-email-landing" element={<VerifyEmailLanding />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </>
  );
}
